import BigNumber from 'bignumber.js';

import { DlVault } from 'types/contracts';

export interface GetClaimableRewardsInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetClaimableRewardsOutput = {
  claimableRewards: BigNumber;
  dynamicRewards?: BigNumber;
  staticRewards?: BigNumber;
};

const getClaimableRewards = async ({
  dlVaultContract,
  accountAddress,
}: GetClaimableRewardsInput): Promise<GetClaimableRewardsOutput> => {
  const res = await dlVaultContract.methods
    .getClaimableRewards(accountAddress)
    .call();

  // 检查返回值是否是新的结构（包含staticReward和networkReward）
  if (res && typeof res === 'object' && 'staticReward' in res && 'networkReward' in res) {
    const staticRewards = new BigNumber((res as any).staticReward || '0');
    const dynamicRewards = new BigNumber((res as any).networkReward || '0');
    const totalRewards = staticRewards.plus(dynamicRewards);

    return {
      claimableRewards: totalRewards,
      staticRewards,
      dynamicRewards,
    };
  }

  // 兼容旧的返回格式
  return {
    claimableRewards: new BigNumber((res as any) || '0'),
  };
};

export default getClaimableRewards; 
